export default theme => ({
  content:{
    backgroundColor:"white"
  },
  sizeTemplate:{
    width:"95%",
    paddingLeft:"45px"
  },
  alignLeft:{
    textAlign:"left",
    paddingLeft:"20px !important"
  },
  alignCenter:{
    textAlign:"center"
  },
  alignRight:{
    textAlign:"right"
  },
  contentWidth:{
    width:"90%"
  },
  buttonSave:{
    backgroundColor:"#ff4500",
    color:"white"
  },
  textGrey:{
    color:"#66788A"
  },
  textGrey10:{
    color:"#66788A",
    fontSize:"10px"
  },
  size12:{
    fontSize:"12px"
  },
  labelFont:1,style:{
    "&.MuiFormLabel-root": {
      fontSize:"12px"
    },
  },
  textError:{
    color:"#ff4500"
  },
  img:{
    width:"55px",
    height:"50px"
  },
  success:{
    backgroundColor: "green",
    height: "30px",
    paddingTop: "4px",
    color:"white"
  }
});
